// ui
import { Button, Typography, Modal, Box } from "@mui/material";
import { useWindowSize } from "../lib/useWindowSize";

interface DataAddModalResultProps {
  onModal: boolean;
  swCloseModal: () => void;
  addModalTitle: string;
  onDataAddModalResult: string;
}

export function DataAddModalResult(props: DataAddModalResultProps) {
  const { onModal, swCloseModal, addModalTitle, onDataAddModalResult } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="data-add-result-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          {addModalTitle}
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {onDataAddModalResult === "success" ? (
            <>
              <Box className="shippori-antique-regular">
                新規作成に成功しました。
              </Box>
              <Box>
                <Button
                  data-testid="data-add-result-success-close"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : onDataAddModalResult === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                データの登録に失敗しました。
                <br />
                いずれかのデータの形式が異なる可能性があります。
              </Box>
              <Box>
                <Button
                  data-testid="data-add-result-failed-close"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box className="shippori-antique-regular">
                {onDataAddModalResult}
              </Box>
              <Box>
                <Button
                  data-testid="data-add-result-other-close"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          )}
        </Typography>
      </Box>
    </Modal>
  );
}
